export const WindowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4444 3H14.6667H12.9883H7.03844H5.33333H4.55556C3.69222 3 3 3.65961 3 4.4658V15.5342C3 16.3404 3.69222 17 4.55556 17H15.4444C16.3 17 17 16.3404 17 15.5342V4.4658C17 3.65961 16.3 3 15.4444 3ZM15.4444 15.5342H4.55556V6.17898H15.4444V15.5342Z"
        fill="#787878"
      />
    </svg>
  )
}
